import { Accordion } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import {
    AdmAddressAccordion,
    AdmEquipmentsAccordion,
    AdmOthersAccordion,
    AdmShippingTab,
    AdmWorkOrdersAccordion,
    FlowControl,
    ChangeStatus
} from '../admAccordion';
import Processing from '../admAccordion/processingManufacturing';
import { useRecoilState } from 'recoil';
import { RmaModelLiteMf } from 'models';
import { RmaLiteMf } from 'resources/atoms/rmaManufaturaAtom';
import OBFAccordion from '../admAccordion/obfManufacturing';

function Administrative(): JSX.Element {
    const { t } = useTranslation(['rmamanufatura', 'common', 'user']);
    const [rmaState, setRmaState] = useRecoilState<RmaModelLiteMf>(RmaLiteMf);

    const hasAddress = () => {
        const hasAddressMf = !!rmaState?.addressId;

        return hasAddressMf;
    };

    const accordionChildren = [
        hasAddress() ? (
            <Accordion.Content title={t('common:translation.Address')}>
                <AdmAddressAccordion rmaState={rmaState} setRmaState={setRmaState} />
            </Accordion.Content>
        ) : null
    ].filter(Boolean);

    return (
        <div className="container-administrative">
            <Accordion>
                <Accordion.Content title={t('common:actions.OrderProcessing')}>
                    <Processing rmaState={rmaState} setRmaState={setRmaState} />
                </Accordion.Content>
                <Accordion.Content title={t('common:translation.Status')}>
                    <ChangeStatus rmaState={rmaState} setRmaState={setRmaState} />
                </Accordion.Content>
                <Accordion.Content title={t('rmamanufatura:translation.FlowControl')}>
                    <FlowControl rmaId={rmaState.id} />
                </Accordion.Content>

                {accordionChildren}

                <Accordion.Content title={t('translation.PV')}>
                    <AdmWorkOrdersAccordion></AdmWorkOrdersAccordion>
                </Accordion.Content>

                <Accordion.Content title={'OBF'}>
                    <OBFAccordion rmaState={rmaState} setRmaState={setRmaState} />
                </Accordion.Content>
            </Accordion>
        </div>
    );
}

export default Administrative;
